import Polyglot from 'node-polyglot';
import { AppConfigService } from '../services/config-service';

const polyglot = new Polyglot();

const lang: string = AppConfigService.getInstance().get('lang', 'en');
polyglot.extend(lang);

export default polyglot;
